// src/pages/staff/components/StaffToolbar.tsx
import React from "react";
import { FormControlLabel, Checkbox, TextField } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";

interface StaffToolbarProps {
  showDeletedStaffs: boolean;
  onToggleDeleted: () => void;
  searchQuery: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddClick: () => void;
}


const StaffToolbar: React.FC<StaffToolbarProps> = ({ showDeletedStaffs, onToggleDeleted, searchQuery, onSearch, onAddClick }) => {
  return (
    <div className="flex w-[89vw] mt-[25px] mb-[15px]" id="staff">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-4 w-full sm:w-[95vw] lg:w-[88vw] min-h-[60px] py-[10px] px-5 rounded-lg">
        <div className="flex items-center" id="view-deleted-staff">
          {/* View Deleted Staffs */}
          <FormControlLabel control={<Checkbox checked={showDeletedStaffs} onChange={onToggleDeleted} />} label="View deleted staffs" />

          {/* Search */}
          <div className="search-box-staff">
            <TextField id="Search-Category-name" label="Search by Staff name or Phone number" variant="outlined" sx={{ width: 370, zIndex: "0" }} type="tel" value={searchQuery} onChange={onSearch} />
          </div>

          {/* Add Staff */}
          <div id="Addcategory">
            <CommonButtons className="w-44 h-10" label="ADD STAFF" onClick={onAddClick} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffToolbar;
